import { render, staticRenderFns } from "./resizer.vue?vue&type=template&id=264a84ec&scoped=true&"
import script from "./resizer.vue?vue&type=script&lang=js&"
export * from "./resizer.vue?vue&type=script&lang=js&"
import style0 from "./resizer.vue?vue&type=style&index=0&id=264a84ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264a84ec",
  null
  
)

export default component.exports